export const defaultStyle = {
  newsContainer: "px-[15px] xl:max-w-xl w-full mx-auto",
  container: "max-w-xl w-full w-[75%] mx-auto",
  containerWrapper:'containerWrapper',
  InputContainer: "w-full",
  dateNews:
    "flex sansFont justify-self-start bg-[#957AA9] text-white leading-[18px] tracking-normal font-bold text-[12px] py-10",
  dateContainer: "w-full pb-30 h-full",
  inputElement:
    "Search w-full h-40 bg-white border-1 text-16 p-10 border-white leading-normal",

  linkPara: "sansFont w-[90%] text-left p-10 leading-[18px] tracking-normal",
  linkColor: "text-purple font-bold text-[12px] leading-[18px] tracking-normal",
  day: "sansFont w-[18%] md:w-[9%] p-[10px] text-[12px] text-nightRider leading-[18px] tracking-normal",
  paraColor: "",
  dateData: "flex items-start text-nightRider hover:bg-slateThick bg-slateLight",
  searchDate: "w-[16%] md:w-[9%] px-10",
  searchNews: "px-[10px]",
  newsDate: "w-3/4 px-10",
  searchContainer: "w-full",
  Para: "text-[12px] ",
  headingTitle:"text-green text-[24px] md:text-[24px] lg:text-[48px] font-Light font-light w-[100%] mb-[35px] leading-[28.8px] md:leading-[28.8px] lg:leading-[57.6px] tracking-normal md:ml-[20px] lg:ml-[0px]"
}
